import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PlanningFixed } from '../../classes/planningfixed.class';
import { ApiService } from '../api/api.service';
import { Features } from '../auth/features';
import { RealtimeService } from '../realtime/realtime.service';
import { WebsocketService } from '../websocket/websocket.service';

@Injectable({
    providedIn: 'root',
})
export class PlanningFixedService extends RealtimeService<PlanningFixed> {
    constructor(
        private apiService: ApiService,
        protected websocketService: WebsocketService
    ) {
        super(websocketService, Features.PlanningFixed, 'id');
    }

    public setFixed(fixedUntil: Date): Promise<PlanningFixed> {
        return this.apiService.postCall('planning/fixed', { fixedUntil });
    }

    public setFixedDay(fixedDate: Date | string): Promise<PlanningFixed> {
        return this.apiService.postCall('planning/fixed-days', { fixedDate });
    }

    public getLatestFixedUntilItem(): Observable<PlanningFixed> {
        return this.getList().pipe(
            map(items => {
                const fixedUntilItems = items.filter(item => !!item.fixeduntil);

                if (!fixedUntilItems.length) {
                    const fallback = new PlanningFixed();
                    fallback.fixeduntil = new Date(0);
                    return fallback;
                }

                return fixedUntilItems.sort((a, b) => (a.id || 0) - (b.id || 0))[fixedUntilItems.length - 1];
            })
        );
    }

    public getFixedDays(): Observable<PlanningFixed[]> {
        return this.getList().pipe(map(items => items.filter(item => !!item.fixed_date)));
    }

    public itemInDaterange(entity: PlanningFixed, fromDate: Date, toDate: Date) {
        return true;
    }
}
